module.exports = __webpack_public_path__ + "img/microsoft.daf18b63.png";